module.exports = __webpack_public_path__ + "static/media/7_l_stol_16.61_71.76.bd74ee5b.png";